import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";

type GoogleUser = {
  name: string;
  email: string;
  picture: string;
  sub: string;
};

export default function Login({ onLogin }: { onLogin: (user: any) => void }) {
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );

        const profile: GoogleUser = await res.json();
        console.log("Google Profile:", profile);
        console.log("API URL:", process.env.REACT_APP_API_URL);

        const backendRes = await fetch(
          `${process.env.REACT_APP_API_URL}/api/login`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(profile),
          }
        );

        const data = await backendRes.json();

        // Update user state and localstorage
        onLogin(data);

        navigate("/edit");
      } catch (error) {
        console.error("Login error", error);
        alert("Login failed");
      }
    },
    onError: () => {
      alert("Google Login Failed");
    },
    flow: "implicit",
  });

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        background:
          "linear-gradient(135deg, rgb(47, 176, 236), rgb(123, 240, 199))",
        color: "#333",
        fontFamily: "'Arial', sans-serif",
      }}
    >
      <div
        style={{
          textAlign: "center",
          marginTop: "10%",
          padding: "20px",
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          maxWidth: "600px",
        }}
      >
        <h1
          style={{
            fontSize: "3rem",
            fontWeight: "bold",
            marginBottom: "1rem",
            color: "green",
          }}
        >
          Storybook Transcreator
        </h1>
        <p
          style={{
            fontSize: "1.25rem",
            marginBottom: "2rem",
          }}
        >
          A Unified Platform for the Translation and Transcreation of Books
        </p>
        <button
          onClick={() => login()}
          style={{
            padding: "15px 30px",
            fontSize: "1.1rem",
            fontWeight: "bold",
            background: "#E75480",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background 0.3s ease",
          }}
          onMouseOver={(e) => (e.currentTarget.style.background = "red")}
          onMouseOut={(e) => (e.currentTarget.style.background = "#E75480")}
        >
          Sign in with Google
        </button>
      </div>

      <div
        style={{
          background: "#ffffff",
          width: "100%",
          padding: "40px",
          textAlign: "center",
          boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            marginBottom: "1rem",
            color: "#264653",
          }}
        >
          Platform Credits
        </h2>
        <p style={{ fontSize: "1rem", color: "#6A6A6A" }}>
          HILITE (2024): platform.opennlplabs.org
        </p>
      </div>
    </div>
  );
}
